<template>
  <div class="post-questionnaire" v-if="questionnaire && questionnaire.length > 0">
    <el-form class="ques-form" ref="quesForm" :model="quesForm" label-position="top" :rules="rules">
      <div class="ques-list">
        <div class="ques-item" v-for="(que, qi) in quesForm.ques" :key="que.tqs_id">
          <div class="ques-title">
            <span class="ques-no">{{ qi + 1 }}、</span>
            <span class="type-text">【{{ questionnaire[qi].tqs_type_text }}】</span>
            <p class="title-text">{{ questionnaire[qi].tqs_content }}
                <span class="is-required" v-if="questionnaire[qi].tqs_is_required == 10">*</span>
            </p>
            
          </div>

          <!-- 单选题 -->
          <template v-if="que.tqs_type == 10">
            <el-form-item :prop="`ques.${qi}.tqa_tqo_id`" 
            :rules="questionnaire[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请选择') }] : []">
              <el-radio-group v-model="que.tqa_tqo_id" @change="handleRadioChange(qi, $event)">
                <div class="radio-ls">
                  <div class="radio-item" v-for="opt in questionnaire[qi].options" :key="opt.tqo_id">
                    <el-radio :label="opt.tqo_id">{{ opt.tqo_content }}</el-radio>
                  </div>
                </div>
              </el-radio-group>
            </el-form-item>
            <div class="probe" v-if="que.tqs_is_probe == 10 && questionnaire[qi].tqs_probe != ''">
              <p class="probe-text">{{ questionnaire[qi].tqs_probe }}</p>
              <el-form-item :prop="`ques.${qi}.tqa_probe`">
                <el-input v-model="que.tqa_probe" type="textarea" :placeholder="$t('请输入')" resize="none" 
                  @focus="handleTextareaFocus(qi, $event)" />
              </el-form-item>
            </div>
          </template>

          <!-- 多选题 -->
          <template v-if="que.tqs_type == 20">
            <el-form-item :prop="`ques.${qi}.tqa_tqo_id`"  
            :rules="questionnaire[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请选择') }] : []">
              <el-checkbox-group v-model="que.tqa_tqo_id" @change="handleCheckboxChange(qi, $event)"
                @click.native="handleCheckboxClick(qi)">
                <div class="checkbox-ls">
                  <div class="checkbox-item" v-for="opt in questionnaire[qi].options" :key="opt.tqo_id">
                    <el-checkbox :label="opt.tqo_id" :disabled="isCheckboxDisabled(qi, opt.tqo_id)">
                      {{ opt.tqo_content }}
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </el-form-item>
            <div class="probe" v-if="questionnaire[qi].tqs_is_probe == 10 && questionnaire[qi].tqs_probe != ''">
                <p class="probe-text">{{ questionnaire[qi].tqs_probe }}</p>
                <el-form-item :prop="`ques.${qi}.tqa_probe`">
                <el-input v-model="que.tqa_probe" type="textarea" :placeholder="$t('请输入')" resize="none" 
                  @focus="handleTextareaFocus(qi, $event)" />
              </el-form-item>
            </div>
          </template>

          <!-- 评分题 -->
          <template v-if="que.tqs_type == 30">
            <el-form-item class="score-item" v-for="(opt, oi) in questionnaire[qi].options" :key="opt.tqo_id"
              :prop="`ques.${qi}.options.${oi}.tqa_score`" 
              :rules="questionnaire[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请选择') }] : []">
              <div class="score-box" :style="{
                '--w': 52 * ((opt.tqo_score_high > 10 && 10) || opt.tqo_score_high) + 'px',
              }">
                <span class="opt-text">{{ opt.tqo_content }}</span>
                <div class="score-radio">
                  <div v-for="score in (opt.tqo_score_high > 10 && 10) ||
                    opt.tqo_score_high" :key="score" @click="handleScoreClick(qi, oi, opt, score)" class="li">
                    <span class="score-num">{{ opt.tqo_score_high > 10 ? score * 10 : score }}</span>
                    <span class="rate-radio" :class="{ light: (opt.tqo_score_high > 10 ? score * 10 : score) == que.options[oi].tqa_score }" />
                  </div>
                </div>
                <p class="stage">
                  <span>{{ opt.tqo_stage_low }}</span>
                  <span>{{ opt.tqo_stage_high}}</span>
                </p>
              </div>
            </el-form-item>
            <div class="probe" v-if="questionnaire[qi].tqs_is_probe == 10 && questionnaire[qi].tqs_probe != ''">
              <p class="probe-text">{{ questionnaire[qi].tqs_probe }}</p>
              <el-form-item :prop="`ques.${qi}.tqa_probe`">
                <el-input v-model="que.tqa_probe" type="textarea" :placeholder="$t('请输入')" resize="none" 
                  @focus="handleTextareaFocus(qi, $event)" />
              </el-form-item>
            </div>
          </template>

          <!-- 主观题 -->
          <el-form-item v-if="que.tqs_type == 40" :prop="`ques.${qi}.tqa_anwser`" 
          :rules="questionnaire[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请输入') }] : []">
            <el-input v-model="que.tqa_anwser" class="large" type="textarea" :placeholder="$t('请输入')" 
              resize="none" @focus="handleTextareaFocus(qi, $event)" />
          </el-form-item>
        </div>
      </div>

      <el-form-item class="sub-btn">
        <el-button @click="subForm" :loading="submitLoading" :disabled="isSubmitted">
          {{ isSubmitted ? $t('已提交') : $t('提交问卷') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getMyInfo } from "@api/home";
import { answerAdd, isAnswer } from "@api/questionnaire";

export default {
  name: "PostQuestionnaire",
  props: {
    questionnaire: {
      type: Array,
      default: () => [],
    },
    tqId: {
      type: [Number, String],
      default: '',
    },
    tpId: {
      type: [Number, String],
      default: '',
    }
  },
  watch: {
    questionnaire: {
      handler(n) {
        if (n && n.length > 0) {
          this.quesForm.ques = [];
          n.map((item) => {
            let obj = {
              tqs_id: item.tqs_id,
              tqs_type: item.tqs_type,
              tqs_is_probe: item.tqs_is_probe,
              tqa_anwser: "",
              tqa_tqo_id: "",
              tqa_probe: "",
              tqa_tqo_probe_arr: [],
              options: [],
            };
            
            // 单选题和多选题的探查题数组初始化
            if (item.tqs_type == 10 || item.tqs_type == 20) {
              if (item.options) {
                item.options.map((oitem) => {
                  obj.tqa_tqo_probe_arr.push({ [oitem.tqo_id]: "" });
                });
              }
            }
            
            /* 多选 */
            if (item.tqs_type == 20) {
              obj.tqa_tqo_id = [];
            } else if (item.tqs_type == 30) {
              /* 评分 */
              if (item.options) {
                item.options.map((opt) => {
                  obj.options.push({
                    tqo_id: opt.tqo_id,
                    tqa_score: null,
                    tqa_tqo_probe: "",
                  });
                });
              }
            }
            this.quesForm.ques.push(obj);
          });
          this.$forceUpdate();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      quesForm: {
        ques: [],
      },
      rules: {},
      submitLoading: false,
      isSubmitted: false, // 是否已提交成功
      userinfo: {}, // 用户信息
    };
  },
  mounted() {
    // 组件加载时获取用户信息
    this.getUserInfo();
  },
  methods: {
    /**
     * 获取用户信息
     */
    async getUserInfo() {
      try {
        const res = await getMyInfo();
        if (res.status == 200) {
          this.userinfo = res.data;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.userinfo = {};
      }
    },

    /**
     * 将用户信息映射为API需要的格式
     */
    mapUserInfoToFormData() {
      return {
        user_id: this.userinfo.user_id || '',
        user_name: this.userinfo.user_name || '',
        user_email: this.userinfo.user_email || '',
        user_mobile: this.userinfo.user_mobile || '',
        register_country: this.userinfo.register_country || '',
        user_company: this.userinfo.user_company || '',
        user_role: this.userinfo.user_role || [],
        user_job: this.userinfo.user_job || '',
        user_industry: this.userinfo.user_industry || ''
      };
    },

    /**
     * 检查用户登录状态
     */
    checkLogin() {
      if (!this.userinfo.user_id) {
        this.$alert(this.$t('请先登录，再填写问卷'), '', {
          confirmButtonText: this.$t('去登录')
        }).then(() => {
          const callback = window.location.href;
          this.$navigate('/login?callback=' + callback, null, false);
        });
        return false;
      }
      return true;
    },

    /**
     * 处理单选题变化
     */
    handleRadioChange(questionIndex, value) {
      if (!this.checkLogin()) {
        // 如果未登录，恢复之前的值
        this.$nextTick(() => {
          this.quesForm.ques[questionIndex].tqa_tqo_id = '';
        });
        return;
      }
    },

    /**
     * 处理多选题点击
     */
    handleCheckboxClick(questionIndex) {
      if (!this.checkLogin()) {
        return;
      }
    },

    /**
     * 处理多选题选择变化
     */
    handleCheckboxChange(questionIndex, selectedValues) {
      if (!this.checkLogin()) {
        // 如果未登录，恢复之前的值
        this.$nextTick(() => {
          this.quesForm.ques[questionIndex].tqa_tqo_id = [];
        });
        return;
      }

      const question = this.questionnaire[questionIndex];
      const maxChoices = question.tqs_max_choices;
      
      // 如果设置了最大选择数量限制
      if (maxChoices && maxChoices > 0) {
        if (selectedValues.length > maxChoices) {
          // 如果超过最大选择数量，移除最后一个选择
          selectedValues.pop();
          this.quesForm.ques[questionIndex].tqa_tqo_id = [...selectedValues];
        }
      }
    },

    /**
     * 处理评分题点击
     */
    handleScoreClick(questionIndex, optionIndex, opt, score) {
      if (!this.checkLogin()) {
        return;
      }
      
      // 设置评分
      this.quesForm.ques[questionIndex].options[optionIndex].tqa_score = 
        opt.tqo_score_high > 10 ? score * 10 : score;
    },

    /**
     * 处理主观题获得焦点
     */
    handleTextareaFocus(questionIndex, event) {
      if (!this.checkLogin()) {
        // 如果未登录，让当前textarea失去焦点
        if (event && event.target) {
          event.target.blur();
        }
        return;
      }
    },

    /**
     * 判断复选框是否应该被禁用
     */
    isCheckboxDisabled(questionIndex, optionId) {
      const question = this.questionnaire[questionIndex];
      const maxChoices = question.tqs_max_choices;
      const currentSelections = this.quesForm.ques[questionIndex].tqa_tqo_id || [];
      
      // 如果没有设置最大选择数量，不禁用
      if (!maxChoices || maxChoices <= 0) {
        return false;
      }
      
      // 如果当前选项已经被选中，不禁用（允许取消选择）
      if (currentSelections.includes(optionId)) {
        return false;
      }
      
      // 如果已选择的数量达到最大值，禁用未选中的选项
      return currentSelections.length >= maxChoices;
    },

    /**
     * 提交问卷表单
     */
    async subForm() {
      let strLanguage = '/cn';
        let Language = localStorage.getItem('currentLanguage');  //获取本地语言
        if (Language && Language != 'zh') {
            strLanguage = '/' + Language;
        }
      // 提交时再次检查登录状态
      if (!this.checkLogin()) {
        return;
      }

      this.$refs.quesForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          
          try {
            // 先检查是否已提交过问卷
            const checkParams = {
              mobile: this.userinfo.user_mobile || '',
              email: this.userinfo.user_email || '',
              tq_id: this.tqId,
              selectEnterTtype: 10,
              tqau_tq_type: 20,
              tqau_content_id: this.tpId
            };

            console.log('检查问卷是否已提交:', checkParams);

            const checkRes = await isAnswer(checkParams);
            if (checkRes.status !== 200) {
              //this.$message.warning(this.$t('您已经提交过该问卷，无需重复提交'));
              this.isSubmitted = true; // 设置已提交状态
              this.submitLoading = false;
              return;
            }

            // 构造提交数据
            const submitData = {
              userFormData: this.mapUserInfoToFormData(),
              ques: this.quesForm.ques,
              tq_id: this.tqId,
              tqau_tq_type: 20,
              tqau_content_id: this.tpId
            };

            //console.log('提交问卷数据:', submitData);

            // 调用API提交问卷
            const res = await answerAdd(submitData);
            
            if (res.status == 200) {
              this.$message.success(this.$t('提交成功'));
              
              // 设置已提交状态，禁用按钮
              this.isSubmitted = true;
              
              // 触发提交完成事件
              this.$emit('submit', submitData);
              // 触发刷新回复列表事件
              this.$emit('questionnaire-submitted');
              if(res.data.tre_ep != 0){
                //return this.$navigate('/rafflelandingpage?tre_ep=' + res.data.tre_ep + '&trer_source_type=40&trer_source_id='+this.tqId, null, false);
                const url = strLanguage+'/rafflelandingpage?tre_ep=' + res.data.tre_ep + '&trer_source_type=40&trer_source_id=' + this.tqId;
                window.open(url, '_blank');
                return;
              }
            } else {
              throw new Error(res.msg || '提交失败');
            }
            
          } catch (error) {
            console.error("Submission failed", error);
            this.$message.error(error.message || this.$t('提交失败，请重试'));
          } finally {
            this.submitLoading = false;
          }
        } else {
          this.$message.warning(this.$t('请完成问卷填写再提交'));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.post-questionnaire {
  margin-top: 26px;
  border-radius: 4px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  background: rgb(255, 255, 255);
  padding: 28px 40px 40px;

  .ques-form {
    max-width: 100%;
    padding: 0;
    box-sizing: border-box;
  }

  .ques-item {
    .ques-title {
      font-size: 14px;
      line-height: 32px;
      color: #191919;
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      font-weight: bold;

      .ques-no {
        margin-right: 0.2em;
      }

      .type-text {
        //color: #1890ff;
        margin-right: 0.2em;
      }

      .title-text {
        margin-right: 0.2em;
        text-align: justify;
        flex: 1;
      }

      .is-required {
        color: #e02128;
        margin-left: 0.2em;
      }
    }

    & + .ques-item {
      margin-top: 16px;
    }

    .radio-item,
    .checkbox-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .opt-text {
        font-size: 14px;
        line-height: 22px;
        color: #191919;
      }

      & + .radio-item,
      & + .checkbox-item {
        margin-top: 12px;
      }
    }

    .score-item {
      .score-box {
        width: var(--w);
        border-bottom: 1px solid #e4e3e3;
        padding-bottom: 6px;
      }

      .opt-text {
        font-size: 14px;
        line-height: 22px;
        color: #191919;
        margin-bottom: 12px;
      }

      .score-radio {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 12px;
        margin-bottom: 10px;

        .li {
          width: 28px;
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: 24px;

          .score-num {
            font-size: 14px;
            line-height: 22px;
            color: #191919;
            margin-bottom: 8px;
          }

          .rate-radio {
            display: inline-block;
            width: 14px;
            height: 14px;
            border-radius: 100%;
            box-sizing: border-box;
            border: 1px solid #595959;
            position: relative;
            transition: all 0.3s ease-in-out;
            cursor: pointer;

            &::after {
              content: "";
              width: 5px;
              height: 5px;
              border-radius: 100%;
              background: #fff;
              box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
              transition: all 0.3s ease-in-out;
              transform: translate(-50%, -50%) scale(0);
              position: absolute;
              top: 50%;
              left: 50%;
            }

            &.light {
              background: #1890ff;
              border-color: #1890ff;

              &::after {
                transform: translate(-50%, -50%) scale(1);
              }
            }
          }
        }
      }

      .stage {
        font-size: 12px;
        line-height: 20px;
        color: #191919;
        justify-content: space-between;
        width: 100%;
        display: flex;
        align-items: center;
      }

      & + .score-item {
        .score-box {
          margin-top: 8px;
        }
      }
    }

    .probe {
      width: 100%;
      margin-top: 12px;

      .probe-text {
        font-size: 14px;
        line-height: 22px;
        color: #191919;
        margin-bottom: 12px;
      }
    }
  }

  .sub-btn {
    width: 100%;
    text-align: center;
    margin-top: 40px;

    .el-button {
      width: 120px;
      height: 40px;
      background: #1890ff;
      border: none;
      line-height: 40px;
      color: #fff;
      border-radius: 20px;
      font-size: 16px;
      padding: 0;

      &:hover {
        background: #40a9ff;
      }

      &:active {
        background: #096dd9;
      }
      
      &:disabled {
        background: #d9d9d9;
        border-color: #d9d9d9;
        color: rgba(0, 0, 0, 0.25);
        cursor: not-allowed;
        
        &:hover {
          background: #d9d9d9;
          border-color: #d9d9d9;
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
  }
}

::v-deep {
  .el-form {
    &-item {
      margin-bottom: 12px;

      &__label {
        font-size: 14px;
        color: #191919 !important;
        line-height: 22px;
        height: 34px;
        padding-bottom: 12px;
        display: flex;
        align-items: center;

        &::before {
          color: #e02128 !important;
          margin-right: 5px !important;
          margin-bottom: -4px;
        }
      }

      &__content {
        min-height: 32px;

        .el-input {
          &__inner {
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            border-color: #dfdfdf;
            color: #191919;

            &::placeholder {
              color: #aeaeae;
            }

            &:focus {
              border-color: #1890ff;
            }
          }
        }

        .el-select {
          width: 100%;
        }

        .el-input.is-focus .el-input__inner {
          border-color: #1890ff;
        }
      }

      &__error {
        white-space: nowrap;
        color: #e02128 !important;
      }

      &.is-error {
        margin-bottom: 24px;

        .el-input__inner,
        .el-input__inner:focus,
        .el-textarea__inner,
        .el-textarea__inner:focus {
          border-color: #e02128;
        }
      }
    }
  }

  .el-tag {
    height: 24px;
    line-height: 24px;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    padding: 0 8px;
    color: #1890ff;
    background: #e6f7ff;
    display: inline-flex;
    align-items: center;
    cursor: default;
    margin-left: 8px;
    font-weight: normal;

    &--info {
      color: #191919;
      background: #f5f6f8;
    }
  }

  .el-textarea {
    border: none;

    &__inner {
      min-height: 48px !important;
      padding: 6px 12px;
      line-height: 22px;
      border: 1px solid #c9c9c9;
      border-radius: 4px;
      font-size: 14px;
      color: #191919;

      &::placeholder {
        color: #aeaeae;
      }

      &:focus {
        border-color: #1890ff;
      }
    }

    &.large .el-textarea__inner {
      min-height: 98px !important;
    }
  }

  .el-checkbox,
  .el-radio {
    line-height: 22px;
    margin-right: 12px;
    display: inline-flex;
    align-items: center;

    &-group {
      width: 100%;
    }

    .el-checkbox,
    .el-radio {
      &__input {
        &.is-checked {
          .el-checkbox,
          .el-radio {
            &__inner {
              border-color: #1890ff;
              background: #1890ff;

              &::after {
                box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
              }
            }
          }

          .el-checkbox__inner::after {
            transform: rotate(0deg) scale(0.7);
          }
        }

        .el-checkbox,
        .el-radio {
          &__inner {
            border-color: #595959;

            &:hover {
              border-color: #1890ff;
            }
          }
        }

        .el-radio__inner {
          &::after {
            content: "";
            width: 5px;
            height: 5px;
            background: #fff;
          }
        }

        .el-checkbox__inner {
          border-radius: 3px;

          &::after {
            content: "\e6da";
            font-family: element-icons !important;
            transform: rotate(0deg) scale(0);
            border: none;
            color: #fff;
            font-size: 12px;
            top: 1px;
            left: 1px;
            text-shadow: 1px 3px 0px rgba(0, 0, 0, 0.3);
          }
        }
      }

      &__inner {
        width: 14px;
        height: 14px;
      }

      &__label {
        padding-left: 8px;
        font-weight: normal;
        color: #191919;
      }
    }
  }

  .el-radio__label {
    white-space: normal;
  }
  
  .el-radio {
    align-items: start;
  }
  
  .el-radio__input {
    margin-top: 3px;
  }
}
</style>
